export default __webpack_public_path__ + "static/media/330_dummy2016-restaurant01-mobile-de.1904fb61.png";